export default __webpack_public_path__ + "static/media/character_red_01.8e1a4806.png";